import { Divider, Theme, Typography, FormControlLabel, Radio, Grid, Alert } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FormInputText } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputText';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  selectIslandsCancel,
  selectIsLicenseSelect,
  selectIsLicenseSelectRadio,
  selectMiscellaneousPlacementData,
  selectPlacementHeaderData,
  selectPlacementLandsGtgDetails,
} from '../../../../../../../store/redux-store/placement-details/selectors';
import { AMNDivision } from 'app/models/enums/AMNDivisionType';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    // padding: '0px 10px',
  },
  sectionTitle: {
    paddingBottom: '6px',
    paddingTop: '6px',
  },
  subTitleStyle: {
    fontWeight: 'bold',
  },
  alignItem: {},
  itemStyle: {
    height: '125',
  },
  alingmentField: {
    paddingLeft: '6px !important',
    paddingRight: '25px !important',
  },
  customAlert: {
    alignItems: 'center',
  },
  alertMessage: {
    padding: '13px 0',
  },
  alertColor: {
    backgroundColor: '#E8F4FD',
  },
  alertIcon: {
    padding: '9px 0',
  },
  messageStyle: {
    textAlign: 'center',
    fontSize: 14,
  },
  radioButtonContainer: {
    marginTop: '4px',
    paddingLeft: '13px',
    display: 'flex',
  },
  alingmentSingleField: {
    paddingTop: '2rem !important',
  },
}));
export const NursysSection = props => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const selectLandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const selectlicense = useSelector(selectIsLicenseSelect);
  const { licensesList } = useSelector(selectMiscellaneousPlacementData);
  const selectlicenseRadio = useSelector(selectIsLicenseSelectRadio);
  const [currentSingleYes, setCurrentSingleYes] = useState<boolean>(selectLandsGtgDetails?.statesInNursys || false);
  const [currentAddressesYes, setCurrentAddressesYes] = useState<boolean>(
    selectLandsGtgDetails?.nursysMatchOnFile || false,
  );
  const [currentMatchesYes, setCurrentMatchesYes] = useState<boolean>(
    selectLandsGtgDetails?.nursysLastnameMatchesLicense || false,
  );
  const [isLicenseSelected, setIsLicenseSelected] = useState<any>();
  const placementHeaderInfo = useSelector(selectPlacementHeaderData);
  const selectiscancel = useSelector(selectIslandsCancel);
  const { formState: { errors }, getValues, setValue, control } = useFormContext();
  useEffect(() => {
    const islicense =
      selectLandsGtgDetails?.licenseNumber ===
        licensesList?.find(x => parseInt(x.requirementID) === selectlicense)?.licenseNumber || selectlicense === null;
    setValue('pSingleYes', islicense ? selectLandsGtgDetails?.statesInNursys || false : false);
    setValue('pSingleNo', islicense ? selectLandsGtgDetails?.statesInNursys || false : false);
    setCurrentSingleYes(islicense ? selectLandsGtgDetails?.statesInNursys || false : false);
    setValue('pAddressesYes', islicense ? selectLandsGtgDetails?.nursysMatchOnFile || false : false);
    setValue('pAddressesNo', islicense ? selectLandsGtgDetails?.nursysMatchOnFile || false : false);
    setCurrentAddressesYes(islicense ? selectLandsGtgDetails?.nursysMatchOnFile || false : false);
    setValue('pMatchesYes', islicense ? selectLandsGtgDetails?.nursysLastnameMatchesLicense || false : false);
    setValue('pMatchesNo', islicense ? selectLandsGtgDetails?.nursysLastnameMatchesLicense || false : false);
    setCurrentMatchesYes(islicense ? selectLandsGtgDetails?.nursysLastnameMatchesLicense || false : false);
    setValue('pSingleReason', islicense ? selectLandsGtgDetails?.statesInNursysReason || '' : '');
    setValue('pAddressesReason', islicense ? selectLandsGtgDetails?.nursysMatchOnFileReason || '' : '');
    setValue('pMatchesReason', islicense ? selectLandsGtgDetails?.nursysLastnameNotMatchesLicenseReason || '' : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectlicenseRadio, selectiscancel]);
  useEffect(() => {
    setIsLicenseSelected(licensesList?.find(x => parseInt(x.requirementID) === selectlicense));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectlicense]);
  const handleSingleReasonChange = e => {
    setValue('pSingleReason', e.target.value, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  const handleAddressesReasonChange = e => {
    setValue('pAddressesReason', e.target.value, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  const handleMatchesReasonChange = e => {
    setValue('pMatchesReason', e.target.value, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  return (
    <>
      <LayoutGrid container direction="column" className={classes.root} spacing={4}>
        <LayoutGridItem item className={classes.sectionTitle}>
          <Typography variant="subtitle1" component="div" className={classes.subTitleStyle}>
            {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.title')}
          </Typography>
        </LayoutGridItem>
        <Divider variant="middle" />
        {selectlicenseRadio &&
        (isLicenseSelected || selectlicense === null) &&
        (isLicenseSelected?.requirementTypeID === 147 ||
          isLicenseSelected?.requirementTypeID === 146 ||
          !isLicenseSelected?.requirementTypeID) &&
        isLicenseSelected?.stateID !== 23 &&
        placementHeaderInfo.facility.amnDivisionType !== AMNDivision.Allied &&
        !(
          selectLandsGtgDetails?.licenseNumber === isLicenseSelected?.licenseNumber &&
          selectLandsGtgDetails?.isAlliedClinician
        ) ? (
          <>
            <LayoutGridItem item className={`${classes.alignItem} ${classes.itemStyle}`}>
              <Typography component="span">
                {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.previouslyLicensedUnderSingleProfile')}
              </Typography>
              <LayoutGrid
                container
                classes={{ root: classes.root }}
                direction="row"
                data-testid="container"
                justifyContent="flex-start"
                spacing={4}
              >
                <LayoutGridItem item xs={4} direction="column" className={classes.alingmentField}>
                  <LayoutGridItem direction="column" className={classes.radioButtonContainer}>
                    <Controller
                      name="pSingleYes"
                      key={'yes'}
                      control={control}
                      render={({ field: { onChange, value, ...rest } }) => (
                        <FormControlLabel
                          name="pSingleYes"
                          key={'yes'}
                          control={
                            <Radio
                              checked={currentSingleYes}
                              onChange={e => {
                                setCurrentSingleYes(true);
                                setValue('pSingleNo', false, { shouldDirty: true });
                                setValue('pSingleYes', true, { shouldDirty: true });
                                setValue('pSingleReason', '', { shouldDirty: true });
                                props.handleFieldChanges?.();
                              }}
                              data-testid={`radio-button-yes`}
                            />
                          }
                          label={t('global.Yes')}
                        />
                      )}
                    />
                    <Controller
                      key={'no'}
                      name="pSingleNo"
                      control={control}
                      render={({ field: { onChange, value, ...rest } }) => (
                        <FormControlLabel
                          key={'no'}
                          name="pSingleNo"
                          control={
                            <Radio
                              checked={!currentSingleYes}
                              onChange={e => {
                                setCurrentSingleYes(false);
                                setValue('pSingleNo', true, { shouldDirty: true });
                                setValue('pSingleYes', false, { shouldDirty: true });
                                props.handleFieldChanges?.();
                              }}
                              data-testid={`radio-button-no`}
                            />
                          }
                          label={t('global.No')}
                        />
                      )}
                    />
                  </LayoutGridItem>
                </LayoutGridItem>
                {!currentSingleYes && (
                  <LayoutGridItem item xs={8} className={classes.alingmentSingleField}>
                    <FormInputText
                      name="pSingleReason"
                      label={`If not, reason `}
                      handleChange={handleSingleReasonChange}
                      require={false}
                      message={errors['pSingleReason']?.message || ''}
                      inputValue={getValues('pSingleReason')}
                      isCheckBox={true}
                    />
                  </LayoutGridItem>
                )}
              </LayoutGrid>
            </LayoutGridItem>
            <LayoutGridItem item className={`${classes.alignItem} ${classes.itemStyle}`}>
              <Typography component="span">
                {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.raduationDatesAddresses')}
              </Typography>
              <LayoutGrid
                container
                classes={{ root: classes.root }}
                direction="row"
                data-testid="container"
                justifyContent="flex-start"
                spacing={4}
              >
                <LayoutGridItem item xs={4} direction="column" className={classes.alingmentField}>
                  <LayoutGridItem direction="column" className={classes.radioButtonContainer}>
                    <Controller
                      name="pAddressesYes"
                      key={'yes'}
                      control={control}
                      render={({ field: { onChange, value, ...rest } }) => (
                        <FormControlLabel
                          name="pAddressesYes"
                          key={'yes'}
                          control={
                            <Radio
                              checked={currentAddressesYes}
                              onChange={e => {
                                setCurrentAddressesYes(true);
                                setValue('pAddressesNo', false, { shouldDirty: true });
                                setValue('pAddressesYes', true, { shouldDirty: true });
                                setValue('pAddressesReason', '', { shouldDirty: true });
                                props.handleFieldChanges?.();
                              }}
                            />
                          }
                          label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.matches')}
                        />
                      )}
                    />
                    <Controller
                      key={'no'}
                      name="pAddressesNo"
                      control={control}
                      render={({ field: { onChange, value, ...rest } }) => (
                        <FormControlLabel
                          key={'no'}
                          name="pAddressesNo"
                          control={
                            <Radio
                              checked={!currentAddressesYes}
                              onChange={e => {
                                setCurrentAddressesYes(false);
                                setValue('pAddressesNo', true, { shouldDirty: true });
                                setValue('pAddressesYes', false, { shouldDirty: true });
                                props.handleFieldChanges?.();
                              }}
                            />
                          }
                          label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.doesNotMatch')}
                        />
                      )}
                    />
                  </LayoutGridItem>
                </LayoutGridItem>
                {!currentAddressesYes && (
                  <LayoutGridItem item xs={8} className={classes.alingmentSingleField}>
                    <FormInputText
                      name="pAddressesReason"
                      label={`${t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.ifNotReason')} `}
                      handleChange={handleAddressesReasonChange}
                      require={false}
                      message={errors['pAddressesReason']?.message || ''}
                      inputValue={getValues('pAddressesReason')}
                      isCheckBox={true}
                    />
                  </LayoutGridItem>
                )}
              </LayoutGrid>
            </LayoutGridItem>
            <LayoutGridItem item className={`${classes.alignItem} ${classes.itemStyle}`}>
              <Typography component="span">
                {t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.doesLastNameMentionedNURSYSLicenseMatches',
                )}
              </Typography>
              <LayoutGrid
                container
                classes={{ root: classes.root }}
                direction="row"
                data-testid="container"
                justifyContent="flex-start"
                spacing={4}
              >
                <LayoutGridItem item xs={4} direction="column" className={classes.alingmentField}>
                  <LayoutGridItem direction="column" className={classes.radioButtonContainer}>
                    <Controller
                      name="pMatchesYes"
                      key={'yes'}
                      control={control}
                      render={({ field: { onChange, value, ...rest } }) => (
                        <FormControlLabel
                          name="pMatchesYes"
                          key={'yes'}
                          control={
                            <Radio
                              checked={currentMatchesYes}
                              onChange={e => {
                                setCurrentMatchesYes(true);
                                setValue('pMatchesNo', false, { shouldDirty: true });
                                setValue('pMatchesYes', true, { shouldDirty: true });
                                setValue('pMatchesReason', '', { shouldDirty: true });
                                props.handleFieldChanges?.();
                              }}
                            />
                          }
                          label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.matches')}
                        />
                      )}
                    />
                    <Controller
                      key={'no'}
                      name="pMatchesNo"
                      control={control}
                      render={({ field: { onChange, value, ...rest } }) => (
                        <FormControlLabel
                          key={'no'}
                          name="pMatchesNo"
                          control={
                            <Radio
                              checked={!currentMatchesYes}
                              onChange={e => {
                                setCurrentMatchesYes(false);
                                setValue('pMatchesNo', true, { shouldDirty: true });
                                setValue('pMatchesYes', false, { shouldDirty: true });
                                props.handleFieldChanges?.();
                              }}
                            />
                          }
                          label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.doesNotMatch')}
                        />
                      )}
                    />
                  </LayoutGridItem>
                </LayoutGridItem>
                {!currentMatchesYes && (
                  <LayoutGridItem item xs={8} className={classes.alingmentSingleField}>
                    <FormInputText
                      name="pMatchesReason"
                      label={`${t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.ifNotReason')} `}
                      handleChange={handleMatchesReasonChange}
                      require={false}
                      message={errors['pMatchesReason']?.message || ''}
                      inputValue={getValues('pMatchesReason')}
                      isCheckBox={true}
                    />
                  </LayoutGridItem>
                )}
              </LayoutGrid>
            </LayoutGridItem>
          </>
        ) : (
          <LayoutGridItem item className={classes.sectionTitle}>
            {!selectlicenseRadio && placementHeaderInfo.facility.amnDivisionType !== AMNDivision.Allied && (
              <Typography variant="subtitle1" component="div" className={classes.messageStyle}>
                {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.selectLicenseAboveVerifyNursys')}
              </Typography>
            )}
            {placementHeaderInfo.facility.amnDivisionType === AMNDivision.Allied ||
            (selectLandsGtgDetails?.licenseNumber === isLicenseSelected?.licenseNumber &&
              selectLandsGtgDetails?.isAlliedClinician) ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  className={classes.customAlert}
                  classes={{
                    message: classes.alertMessage,
                    standardInfo: classes.alertColor,
                    icon: classes.alertIcon,
                  }}
                >
                  {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.nursysVerificationNotNeededForAllied')}
                </Alert>
              </Grid>
            ) : selectlicenseRadio &&
              isLicenseSelected &&
              isLicenseSelected?.requirementTypeID !== 147 &&
              isLicenseSelected?.requirementTypeID !== 146 ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  className={classes.customAlert}
                  classes={{
                    message: classes.alertMessage,
                    standardInfo: classes.alertColor,
                    icon: classes.alertIcon,
                  }}
                >
                  {t(
                    'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.nursysVerificationOnlyRequiredForRNLPNLicenses',
                  )}
                </Alert>
              </Grid>
            ) : (
              selectlicenseRadio &&
              (isLicenseSelected?.requirementTypeID === 147 || isLicenseSelected?.requirementTypeID === 146) &&
              isLicenseSelected?.stateID === 23 && (
                <Grid item xs={12}>
                  <Alert
                    severity="info"
                    className={classes.customAlert}
                    classes={{
                      message: classes.alertMessage,
                      standardInfo: classes.alertColor,
                      icon: classes.alertIcon,
                    }}
                  >
                    {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.nursys.nursysVerificationRequiredMichigan')}
                  </Alert>
                </Grid>
              )
            )}
          </LayoutGridItem>
        )}
      </LayoutGrid>
    </>
  );
};
